// --- Tablo genişliği yardımcıları (Mac/Apple görüntüleyici uyumu) ---------
// Apple yerleşik görüntüleyiciler tablo sütunlarını MS Word gibi otomatik
// boyutlandırmadığından tablolara SABİT (DXA/twip) genişlik vermek gerekir.
// A4 portre genişliği 11906 twip; 1 cm ≈ 567 twip.
export const PAGE_WIDTH_PORTRAIT = 11906;
const CM_TWIP = 567;

// margins {left,right} cm cinsinden → kullanılabilir içerik genişliği (twip).
export const getContentWidth = (margins = { left: 2, right: 2 }) =>
  PAGE_WIDTH_PORTRAIT - Math.round(((margins.left || 0) + (margins.right || 0)) * CM_TWIP);

// Varsayılan kenar boşluğu (sol/sağ 2 cm) ile içerik genişliği.
export const DEFAULT_CONTENT_WIDTH = PAGE_WIDTH_PORTRAIT - Math.round((2 + 2) * CM_TWIP); // 9638

// Toplam genişliği verilen oranlara böler; yuvarlama farkını son sütuna ekler.
export const splitWidth = (total, ratios) => {
  const raw = ratios.map((r) => Math.floor(total * r));
  const used = raw.reduce((a, b) => a + b, 0);
  if (raw.length) raw[raw.length - 1] += total - used;
  return raw;
};

// Toplam genişliği n eşit sütuna böler.
export const equalWidths = (total, n) => splitWidth(total, Array(Math.max(n, 1)).fill(1 / Math.max(n, 1)));

export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

export const createTableCell = (content, options = {}) => {
    const { bold = false, alignment = 'left', fill = null } = options;
    return {
        children: [
            {
                type: 'paragraph',
                children: [
                    {
                        type: 'text',
                        text: content,
                        bold: bold,
                    },
                ],
            },
        ],
        alignment: alignment,
        ...(fill && { shading: { fill: fill } }),
    };
};

export const createTableRow = (cells) => {
    return {
        children: cells,
    };
};